<div class="attachment-viewer" *ngIf="attachments?.length; else empty">
  <h4 *ngIf="!compact" class="viewer-title">{{ label }}</h4>
  <div class="chips">
    <button
      *ngFor="let att of attachments"
      type="button"
      class="chip"
      [class.compact]="compact"
      [disabled]="loadingId === att.id"
      (click)="onClick(att)">
      <mat-icon [style.color]="colorFor(att.fileType, att.fileName)">
        {{ iconFor(att.fileType, att.fileName) }}
      </mat-icon>
      <span class="file-name">{{ att.fileName }}</span>
      <mat-icon *ngIf="loadingId === att.id" class="spinner">hourglass_empty</mat-icon>
      <mat-icon *ngIf="loadingId !== att.id" class="open-icon">visibility</mat-icon>
    </button>
  </div>
</div>

<ng-template #empty>
  <div *ngIf="!compact" class="empty">{{ emptyText }}</div>
</ng-template>
